import React from "react"
import PaymentLogNotes from "../PaymentBuilder/PaymentLogNotes"
import PaymentLogPresenterPaymentLogFoliosWidget from "./PaymentLogPresenterPaymentLogFoliosWidget"
import DateHelper from "../DateHelper/DateHelper"
import EditPaymentLogTimeLine from '../PaymentBuilder/EditPaymentLogTimeLine';
import I18n from "i18n-js";

class PaymentLogPresenterWorkspace extends React.Component {
  constructor(props) {
    super(props);
  };

  render() {
    
    if (this.props.activeTab === 'general') {
      return (
        <div>
          {<EditPaymentLogTimeLine {...this.props} />}
          {this.renderPaymentLogFolios()}
          {this.renderPaymentDetails()}
        </div>
      );
    } else if (this.props.activeTab === 'notes') {
      return (
        <PaymentLogNotes {...this.props}/> 
      );
    };
  };

  renderPaymentLogFolios() {
    return(
      <PaymentLogPresenterPaymentLogFoliosWidget {...this.props} />
    );
  };

  renderPaymentDetails() {
    return (
      <div className="payment-details">
        <div className="panel panel-default">
          <div className="panel-body container">
            <h3 className="panel-heading-text" style={{ borderBottom: '1px solid #DFDFDF' }}>{I18n.t('payment_details')}</h3>
            <div className="row" style={{ margin: '0px' }}>
              {this.renderPaymentTotal()}
              {this.props.payment_type.name === 'cash' ? null : this.renderPaymentRefund()}
              {this.renderPaymentCustomer()}
              {this.props.payment_type.name === 'cash' ? this.renderCashDrawer() : this.renderPaymentCard()}
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderCashDrawer() {
    return (
      <div className="col-sm-3">
        <label>{I18n.t('cash_drawer')}</label>
        <br />
        <div>{this.props.payment_log.cash_drawer.code} - {this.props.payment_log.cash_drawer.name}</div>
      </div>
    );
  }

  renderPaymentTotal() {
    return (
      <div className="col-sm-3">
        <label>{I18n.t('payment_total')}</label>
        <br />
        <div>{this.props.formatCurrency(this.props.payment_log.amount)}</div>
      </div>
    );
  };

  renderPaymentRefund() {
    return (
      <div className="col-sm-3">
        <label>{I18n.t('amount_refunded')}</label>
        <br />
        <div>{this.props.formatCurrency(this.props.payment_log.amount_refunded)}</div>
      </div>
    );
  };

  renderPaymentCustomer() {
    if (this.props.payment_log.card){
      return (
        <div className="col-sm-3">
          <label>{I18n.t('name_on_card')}</label>
          <br />
          <div>{this.props.payment_log.card.first_name + ' ' + this.props.payment_log.card.last_name}</div>
        </div>
      );
    } else{
      return (
        <div className="col-sm-3">
          <label>{I18n.t('customer')}</label>
          <br />
          <div>{this.props.payment_log.customer.first_name + ' ' + this.props.payment_log.customer.last_name}</div>
        </div>
      );
    };
  };

  renderPaymentCard() {
    if (this.props.payment_log.payment_type.name != 'rentals_united'){
      return (
        <div className="col-sm-3">
          <label>{I18n.t('card')}</label>
          <br />
          <span className={"credit-card-icon small " + this.props.payment_log.card.brand} style={{ marginRight: 0, marginLeft: -10, border: 'none' }}></span>
          {I18n.t('ending_in').toLowerCase()} <strong>{this.props.payment_log.card.last_4}</strong> {I18n.t('exp')} <strong>{this.props.payment_log.card.month}/{this.props.payment_log.card.year}</strong>
        </div>
      );
    } else {
      return null;
    };
  };
};

export default PaymentLogPresenterWorkspace